import { HelpMedia } from '@/components/layout/HelpMedia'
import { MarkdownBody } from './HelpMarkdown'
import type { HelpArticle } from './helpApi'

/**
 * An article's content, shared by the quick view and the Help page: a
 * clinical reference's source and reviewer, the how-to media, then the body
 * with its `claro:` links going through `onNavigate`.
 */
export function HelpArticleContent({
  article,
  onNavigate,
}: {
  article: HelpArticle
  onNavigate: (webPath: string) => void
}) {
  return (
    <div className="space-y-6">
      {article.content_type === 'clinical_reference' && (article.evidence_source || article.reviewed_by) && (
        <div className="px-3 py-2 rounded-lg bg-claro-50 border border-claro-100 flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px]">
          {article.evidence_source && (
            <span className="text-claro-700">
              <span className="font-medium">Source:</span> {article.evidence_source}
            </span>
          )}
          {article.reviewed_by && (
            <span className="text-claro-600">
              Reviewed by {article.reviewed_by}
              {article.last_reviewed && ` (${article.last_reviewed})`}
            </span>
          )}
        </div>
      )}
      {article.media && <HelpMedia media={article.media} title={article.title} />}
      {/* Older backends send no `links`: their claro: links are plain text. */}
      <MarkdownBody content={article.body} links={article.links ?? {}} onNavigate={onNavigate} />
    </div>
  )
}
